import { MotionDiv } from '@/components/element/MotionDiv';
import { useQuotationTaskDocuments } from '@/hooks/api/1540_quotation_task_documents';
import { useCurrentQuotationTask } from '@/providers/QuotationTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { isApprovalURL, isBackofficeURL } from '@/utils';
import { Fragment, useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

export const TaskFiles = () => {
  const location = useLocation();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { sales_order_id } = useParams();
  const { quotationTask: task } = useCurrentQuotationTask();
  const { data: documents } = useQuotationTaskDocuments({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    sales_order_id: Number(sales_order_id),
    task_id: task!.id,
  });
  const [editPagePath, setEditPagePath] = useState<string>('');

  useEffect(() => {
    if (isBackofficeURL(location.pathname)) {
      setEditPagePath(
        (_) =>
          `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/sales_orders/${sales_order_id}/quotation_tasks/${
            task!.id
          }/quotation_task_files`
      );
    } else if (isApprovalURL(location.pathname)) {
      setEditPagePath(
        (_) =>
          `/w/${_w_!.identifier}/approval/teams/${_t_!.id}/sales_orders/${sales_order_id}/quotation_tasks/${
            task!.id
          }/quotation_task_files`
      );
    } else {
      setEditPagePath(
        (_) =>
          `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${sales_order_id}/quotation_tasks/${
            task!.id
          }/quotation_task_files`
      );
    }
  }, [location.pathname]);

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-0">見積書等ファイル一覧</h6>
        </div>
        {['preparing', 'request_approval'].includes(task!.quotation_task_phase.name) && (
          <Link to={editPagePath} className="btn btn-outline-success btn-icon-only">
            <i className="fa fa-edit"></i>
          </Link>
        )}
      </div>
      <div className="card-body pt-0">
        {documents?.map((d, i) => (
          <Fragment key={`qtd-${d.id}`}>
            {i != 0 && <hr className="horizontal dark" />}
            {d.url && (
              <Link to={d.url} target={'_blank'} className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="icon icon-sm bg-dark d-flex border-radius-md align-items-center justify-content-center flex-shrink-0">
                    <i className="fas fa-external-link-alt text-white"></i>
                  </div>
                  <div className="ms-2">
                    <div className="font-weight-bold px-0 text-sm text-dark mb-1">{d.name}</div>
                  </div>
                </div>
                <i className="fas fa-angle-right text-muted opacity-3 flex-shrink-0 ms-2"></i>
              </Link>
            )}

            {d.file_url && (
              <a
                href={d.file_url!}
                target="_blank"
                className="d-flex align-items-center justify-content-between"
                rel="noreferrer"
              >
                <div className="d-flex align-items-center">
                  <div className="icon icon-sm bg-dark d-flex border-radius-md align-items-center justify-content-center flex-shrink-0">
                    <i className="fas fa-download text-white"></i>
                  </div>
                  <div className="ms-2">
                    <div className="font-weight-bold px-0 text-sm text-dark mb-1">{d.name}</div>
                  </div>
                </div>
                <i className="fas fa-angle-right text-muted opacity-3 flex-shrink-0 ms-2"></i>
              </a>
            )}
          </Fragment>
        ))}
      </div>
    </MotionDiv>
  );
};
